const axios = require("axios");

export const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};

export const getStagesCount = async (pip) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `pipelines/${pip}/stages/count`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};


export const getStripeLink = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `company/settings/stripe`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};


export const getDealsFieldsCount = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `deals/schema/count`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getStages = async (pip, limit, offSet) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `pipelines/${pip}/stages?limit=${limit}&offset=${offSet}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};


export const getDeals = async (limit, offSet) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `deals/schema?limit=${limit}&offset=${offSet}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getPiplines = async (limit, offSet) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `pipelines?limit=${limit}&offset=${offSet}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getPiplinesCount = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `pipelines/count`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const addStage = async (id, stage) => {
    const response = await axios({
        method: "post",
        url: process.env.REACT_APP_API_BASE_URL + `pipelines/${id}/stages`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: {
            label: stage,

        },
    });
    return response.data;
};

export const addPipeline = async (pipeline) => {
    const response = await axios({
        method: "post",
        url: process.env.REACT_APP_API_BASE_URL + `pipelines`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: {
            name: pipeline,
        },
    });
    return response.data;
};

export const editPipelineApi = async (id, body) => {
    const response = await axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + `pipelines/${id}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: body
    });
    return response.data;
};

export const addField = async (body) => {
    const response = await axios({
        method: "post",
        url: process.env.REACT_APP_API_BASE_URL + `deals/schema`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: body
    });
    return response.data;
};

export const editFieldApi = async (id, body) => {
    const response = await axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + `deals/schema/${id}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: body
    });
    return response.data;
};

export const editStageApi = async (id, stageId, body) => {
    const response = await axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + `pipelines/${id}/stages/${stageId}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: body
    });
    return response.data;
};

export const saveOrderApi = async (pip, order) => {
    const response = await axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + `pipelines/${pip}/stages`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: { stages: order }
    });
    return response.data;
};


export const getCompanySettings = async () => {
    const response = await axios({
        method: "get",
        url: process.env.REACT_APP_API_BASE_URL + `company/settings`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },

    });
    return response.data;
};

export const getStates = async () => {
    const response = await axios({
        method: "get",
        url: process.env.REACT_APP_API_BASE_URL + `states`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },

    });
    return response.data;
};

export const putCompanySettings = async (body) => {
    const response = await axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + `company/settings`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: body

    });
    return response.data;
};